
import React from 'react'
import alonAhoron from "../../assets/images/AlonAhoron.png"
import EinavPincu from "../../assets/images/EinavPincu.png"
import OzMoyal from "../../assets/images/OzMoyal.png"
import ShayGoldberg from "../../assets/images/ShayGoldberg.png"
import inlikdin from "../../assets/icons/inlikdin.svg"
import useFlickerEffect from '../../hooks/useFlickerEffect.ts'

const About = () => {
    const activeClass = useFlickerEffect();

    return (
        <>
            <section
                id='aboutus'
                className={`md:py-[120px] py-[60px] relative
                         after:hidden 
                         after:xl:block
                         after:absolute 
                         after:max-w-[267px] 
                         after:w-full 
                         after:h-[700px] 
                         after:top-[300px] 
                         after:left-0 
                         after:bg-[url('../src/assets/images/lefteffect3.png')]
                         after:bg-no-repeat
                    ${activeClass && 'after:animate-flicker'} `}
            >
                <div className='container' >
                    <h2 style={{ textShadow: "0px 0px 20px #2972D7" }} className='pb-[30px] md:pb-[60px] text-nowrap text-[20px] sm:text-[26px] sm:text-4xl md:text-[50px] text-white text-center font-gothicproMedium leading-[52px]  drop-shadow-custom relative z-20 '>// SOBRE NOSOTROS</h2>
                    <div className='md:space-y-8 space-y-3 max-w-[1025px] w-full mx-auto' >
                        <h3 className='lg:text-[28px] md:text-[22px] text-base font-gothicproMedium text-[#E2EEFF]' >
                            <span className='text-[#2972D7]' >
                            ARMORY
                            </span> nació con un objetivo:
                        </h3>
                        <p className='lg:text-[22px] md:text-[20px] text-base font-normal font-inter text-[#C9C9C9] ' >Cambiar las reglas del juego en ciberseguridad. Mientras otros reaccionan, nosotros predecimos. Mientras otros escanean, nosotros simulamos. Al replicar las tácticas reales de los hackers, descubrimos vulnerabilidades que las herramientas tradicionales pasan por alto, dándote el poder de neutralizar amenazas antes de que escalen.</p>
                        <h3 className='lg:text-[28px] md:text-[22px] text-base font-gothicproMedium text-[#E2EEFF]' >
                        Si los hackers no esperan, 
                            <span className='text-[#2972D7] ml-1' >
                            ¿por qué habrías de hacerlo tú?
                            </span>
                        </h3>
                        <p className='lg:text-[22px] md:text-[20px] text-base font-normal font-inter text-[#C9C9C9] ' >Detrás de Armory hay un equipo de hackers ofensivos con años de experiencia, que han pensado, actuado y operado como atacantes reales.</p>
                    </div>
                    <div className="
                    
                    " >
                        
                    </div>
                </div>
            </section >
        </>
    )
}

export default About


